import React, { useState, useEffect, useRef } from 'react';
import ApiHandler from "./../../../../../services/api/ApiHandler";
import apiPayload from './../../../../../services/api/ApiPayload';
import localStorageService from './../../../../../helpers/store/StorageService';
import CloudLoader from './../../../loader/Loader_02';
import HorizontalLine from './../../../shared/shapes/HorizontalLine';

const AuthUserAccount = ({ initError, initLoader }) => {
  const hasRun = useRef(false);  // Ref to track if effect has run
  let { data, loading, error, handlePostApi } = ApiHandler();
  const [isLoading, setIsLoading] = useState(false);
  const [serverError, setServerError] = useState(null);
  const [isSuccess, setIsSuccess] = useState(false);
  const [firstName, setFirstName] = useState(null);
  const [lastName, setLastName] = useState(null);
  const [email, setEmail] = useState(null);
  const [phone, setPhone] = useState(null);
  const [referralCode, setReferralCode] = useState(null);

  useEffect(() => {
    if (hasRun.current) return;  // Skip if already run
    let isMounted = true;
    if (isMounted) {
      setIsLoading(true);
      setServerError(null);
      setIsSuccess(false);
      try {
        apiPayload.set('load.pageId', 'Page30009');
        apiPayload.set('load.redirectRoute', '/auth/user/account');
        apiPayload.set('load.data.userId', localStorageService.get('active', -1, 'int'));
        handlePostApi("/v1/user/account", apiPayload.fetchPayload());
      } catch (err) {
        setServerError({ general: 'API error', error: error });
        console.warn(err);
      } finally {
        setIsLoading(false);
      }
    }

    hasRun.current = true;  // Flag as run

    // Cleanup to prevent updates after unmount
    return () => {
      isMounted = false;
    };
    // TODO : Clear the warning
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
      if (data && data.code === "200") {
        setIsSuccess(true);
        let email_id = data.result.api_request_data.email;
        let phone_number = data.result.api_request_data.phone;

        setFirstName(data.result.api_request_data.firstName);
        setLastName(data.result.api_request_data.lastName);
        
        // Mask email: Show first 4 chars, mask rest before @
        setEmail(email_id ? email_id.slice(0, 4) + 'xxxxxx' + email_id.slice(email_id.indexOf('@')) : 'N/A');

        // Mask phone: Show last 4 digits, mask first
        setPhone(phone_number ? 'xxxxxx' + String(phone_number).slice(-4) : 'N/A');

        setReferralCode(data.result.api_request_data.referralCode);
      } else if (data && data.code !== "200") {
        setServerError({ general: data.result.api_request_data.error });
      }
    }, [data]);

  const handleCopy = () => {
    navigator.clipboard.writeText(referralCode).then(() => {
      console.info('Referral code copied!');
    }).catch(() => {
      console.warn('Failed to copy!');
    });
  };

  return (
    <div>
      {initLoader && isSuccess && <CloudLoader />}
      {loading && isSuccess && <CloudLoader />}
      {isLoading && isSuccess && <CloudLoader />}
      {isSuccess && (
      <div className="account-page">
        <span className='account-title'>
          <span className="green-led"></span>&nbsp;<span style={{fontSize:'20px'}}> Account Center</span>
        </span>
        <HorizontalLine/>
        <div className="detail-item">
          <label className='account-data-label'>Full Name</label>
          <p className='account-data-value'>{firstName + ' ' + lastName}</p>
        </div>
        <HorizontalLine/>
        <div className="detail-item">
          <label className='account-data-label'>Phone Number</label>
          <p className='account-data-value'>{phone}</p>
        </div>
        <HorizontalLine/>
        <div className="detail-item">
          <label className='account-data-label'>Email ID</label>
          <p className='account-data-value'>{email}</p>
        </div>
        <HorizontalLine/>
        <div className="detail-item referral">
          <label className='account-data-label'>Referral Code</label>
          <p className='account-data-value'>{referralCode}</p>
          <button className="copy-btn" onClick={handleCopy}>Copy</button>
        </div>
        <HorizontalLine/>
        <div className="detail-item">
          <p className='account-data-label'>For Account Deletion, Mail us on</p>
          <br/>
          <p className='account-data-value'>vexel.cyber.pix@gmail.com</p>
        </div>
      </div>)}
      {serverError?.general && <span className="error">{serverError.general}</span>}
      {initError && <span className="error">{initError}</span>}
    </div>
  );
};

export default AuthUserAccount;
